import React from 'react';
import classNames from 'classnames';

import styles from './style.scss';


class DropDownMenu extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isOpen: false,
    };
    this.dropDownMenuRef = React.createRef();
    this.handleClickOutside = this.handleClickOutside.bind(this);
  }

  componentDidMount() {
    document.addEventListener('mousedown', this.handleClickOutside, false);
    document.addEventListener('touchend', this.handleClickOutside, false);
  }

  toggleMenu() {
    const { isOpen } = this.state;
    this.setState({ isOpen: !isOpen });
  }

  handleClickOutside(e) {
    const { isOpen } = this.state;
    if (!this.dropDownMenuRef.current.contains(e.target) && isOpen) {
      this.setState({ isOpen: false });
    }
  }

  handleBlur() {
    this.setState({ isOpen: false });
  }

  handleRef(elem) {
    if (elem) {
      elem.focus();
    }
  }

  handleStopBlur(event) {
    event.preventDefault();
  }

  getChildrenItems() {
    const { children } = this.props;
    return React.Children.map(children, (item) => {
      const props = {
        onMouseDown: (event) => this.handleStopBlur(event),
        className: classNames(styles.item, item.props.className),
      };
      return (
        React.cloneElement(item, props)
      );
    });
  }

  render() {
    const { isOpen } = this.state;
    const { extraClassName, extraClassNameDropMenu, type } = this.props;
    return (
      <div className={classNames(styles.menu, extraClassName)} ref={this.dropDownMenuRef}>
        <span
          className={classNames(styles.menuToggle, styles[`type-${type}`], 'jest-drop-down-menu')}
          onClick={() => this.toggleMenu()}>
          Изменить
        </span>
        {isOpen && (
          <div
            tabIndex="-1"
            ref={(elem) => this.handleRef(elem)}
            onBlur={() => this.handleBlur()}
            className={classNames(styles.menuItemList, extraClassNameDropMenu)}>
            {this.getChildrenItems()}
          </div>
        )}
      </div>
    );
  }
};

DropDownMenu.defaultProps = {
  extraClassName: '',
  extraClassNameDropMenu: '',
  type: 'edit',
};

export default DropDownMenu;
